export const setCookie = function(c_name, value, expiredays) {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
}
// 获取cookie
export const getCookie = function(cname) {
    let name = cname + '='
    let ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') c = c.substring(1)
        if (c.indexOf(name) != -1) return c.substring(name.length, c.length)
    }
    return ''
}
let userCommunity = null
let currentuserCommunity = null

export const setuserToken = function(token){
    localStorage.setItem('globaluserToken',token)

}
export const getuserToken = function(){
  if(isIos() || isAndroid()) {
    let appuserToken = localStorage.getItem('appuserToken')
    return appuserToken
  }else{
    return localStorage.getItem('globaluserToken') || ''
  }
}

export const setuserCommunity = function(obj){
    userCommunity = obj;
    localStorage.setItem('globaluserCommunity',JSON.stringify(obj || {}))
}
export const getuserCommunity = function(){
    if(!userCommunity){
        userCommunity = JSON.parse(localStorage.getItem('globaluserCommunity'))
    }
    return userCommunity
}

export const setcurrentuserCommunity = function(obj){
    currentuserCommunity = obj;
    localStorage.setItem('currentuserCommunity',JSON.stringify(obj || {}))
}
export const getcurrentuserCommunity = function(){
    if(!currentuserCommunity){
        currentuserCommunity = JSON.parse(localStorage.getItem('currentuserCommunity'))
    }
    return currentuserCommunity
}

export const setMovetime = (obj) => {
    localStorage.setItem('moveTime',obj)
}

export const getMovetime = () => {
    return localStorage.getItem('moveTime') || 0
}
export const ischeckLogin = () => {
    let appuserToken = localStorage.getItem('appuserToken')
    if(getuserToken()!=''||appuserToken!='') {
        return true
    }
    return false
}

export function isIframe () {
    // 不含
    if(window.location.href.indexOf('iframeId')==-1) {
      return true;
    }else{
      return false;
    }
}

export function isCheckUrl(url,type) {
  if(url.indexOf(commonIp())!=-1 || /^\/[^\/]/.test(url)){
    return true
  }else{
    return false
  }
}

//判断是否是安卓还是ios  
export function isAndroid(){
  var u = navigator.userAgent, app = navigator.appVersion;
  var isAndroid = u.indexOf('Android') > -1 ; //android终端或者uc浏览器  
  var isAndroidApp = u.indexOf('jingcaishenghuo') > -1 ; //android终端或者uc浏览器
  return isAndroid && isAndroidApp;  
}
export function isIos(){
  var u = navigator.userAgent, app = navigator.appVersion;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端  
  var isiOSApp =  u.indexOf('jingcaishenghuo') > -1; //ios终端  
  return isiOS && isiOSApp;  
}

// 设置公共ip
export function commonIp() {
  if(window.location.href.indexOf('https')>-1) {
    if(window.location.href.indexOf('api.linyouquan.net')>-1) {
        return 'https://api.linyouquan.net'
    }else{
        return 'https://dev.linyouquan.net'
    }
  }else{
    if(window.location.href.indexOf('localhost:8080')>-1) {
      return 'http://localhost:8080'
    }else if(window.location.href.indexOf('api.linyouquan.net')>-1) {
      return 'http://api.linyouquan.net'
    }else{
      return 'http://dev.linyouquan.net'
    }
  }
}



// WEBPACK FOOTER //
// ./src/global.js